import { ALERTS_STATE } from './constants'
import type { IAlertsState } from './state'

export const getAlert = (state: IAlertsState) => state[ALERTS_STATE]
